// reach_ui/src/components/VastGPT/RelevantInfoExpansionPanel.js
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  withStyles,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Typography,
} from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons'
import { toggleDialog } from '../../actions/view'
import { setRelevantInfoExpanded } from './redux'

const styles = theme => ({
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightRegular,
  },
})

class RelevantInfoExpansionPanel extends Component {
  render() {
    const {
      classes,
      relevantInfo,
      relevantInfoExpanded,
      setRelevantInfoExpanded,
    } = this.props

    return (
      <ExpansionPanel
        expanded={relevantInfoExpanded}
        onChange={() => setRelevantInfoExpanded(!relevantInfoExpanded)}
      >
        <ExpansionPanelSummary expandIcon={<ExpandMore />}>
          <Typography className={classes.heading}>
            Relevant information
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <ul>
            {relevantInfo?.map((info, index) => {
              return (
                <li
                  style={{
                    color: 'blue',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                  }}
                  key={`relevantInfo${index}`}
                  onClick={() =>
                    this.props.toggleDialog({
                      open: true,
                      dialog: 'AddOrEditKnowledge',
                      options: {
                        id: info.id,
                      },
                    })
                  }
                >
                  {info.title}
                </li>
              )
            })}
          </ul>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    )
  }
}

export default connect(
  state => ({
    relevantInfoExpanded: state.VastGPT.relevantInfoExpanded,
    relevantInfo: state.VastGPT.relevantInfo,
  }),
  dispatch =>
    bindActionCreators({ toggleDialog, setRelevantInfoExpanded }, dispatch),
)(withStyles(styles)(RelevantInfoExpansionPanel))
